import request from '@utils/request'

export const state = {
  cachedCart: {},
  cachedPrepaidCart: {},
  cachedSelect: {},
};

export const getters = {};

export const mutations = {
  CACHE_CART(state, cartParams) {
    state.cachedCart = cartParams
  },
  CACHE_PREPAID_CART(state, cartParams) {
    state.cachedPrepaidCart = cartParams
  },
  CACHE_SELECT(state, selectParams) {
    state.cachedSelect = selectParams
  },
};

export const actions = {
  checkCoupon({ commit }, params) {
    return request
      .get('/coupon', {
        params
      })
  },
  updateCart({ commit }, newCartParams = {}) {
    commit('CACHE_CART', newCartParams)
  },
  updatePrepaidCart({ commit }, newCartParams) {
    commit('CACHE_PREPAID_CART', newCartParams)
  },
  updateSelect({ commit }, newSelectParams) {
    commit('CACHE_SELECT', newSelectParams)
  },
  updateSessionCart({ commit }, newCartParams) {
    return request
      .post(`/cart/add`, {
        ...newCartParams
      })
  },
  /*
  * 結帳購物車
  * */
  checkOut({ commit }, {cart, checkoutType}) {
    let checkoutURL = '/cart/checkout';

    if(cart.orderId) {
      if(checkoutType === 'prepaid') {
        checkoutURL = `/prepaid/order/${cart.orderId}/checkout`
      }else {
        checkoutURL = `/order/${cart.orderId}/checkout`
      }
    }else {
      checkoutURL = '/cart/checkout'
    }

    return request
      .post(checkoutURL, {
        ...cart
      })
  },
  /*
  * 取得單一訂單
  * */
  fetchOrder({ commit }, { orderKey }) {
    return request
      .get(`/order/${orderKey}`, { errorHandle: false })
  },
  /*
  * 取得單一訂單QR CODE
  * */
  fetchOrderTickets({ commit }, { orderKey }) {
    return request
      .get(`/order/${orderKey}/tickets`, { errorHandle: false })
  },
  /*
  * 取得所有訂單
  * */
  fetchOrders({ commit }, params) {
    return request
      .post(`/merchant/member/order/search`, {
        limit: 8,
        ...params,
      })
  },

  /*
  * 取得所有方案訂單
  * */
  fetchPrepaidOrders({ commit }, params ) {
    return request
      .post(`/merchant/member/prepaid/order/search`, {
        limit: 8,
        ...params,
      })
  },
  /*
  * 取得單一方案訂單
  * */
  fetchPrepaidOrder({ commit }, { orderKey }) {
    return request
      .get(`/prepaid/order/${orderKey}`, { errorHandle: false })
  },
  /*
  * 取得單一方案訂單可抵用活動
  * */
  fetchPrepaidOrderAvailable({ commit }, {productAlias}) {
    return request
      .post(`/merchant/member/prepaid/order/available`, {
        productAlias
      })
  },
  /*
  * 驗證抵用
  * */
  fetchOrderDeduct({ commit }, { orderKey, verificationCode, byOrderExtrafields, bySizeExtrafields }) {
    return request
      .post(`/order/${ orderKey }/deduct`, {
        verificationCode,
        byOrderExtrafields,
        bySizeExtrafields
      })
  },
};
